import React , { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  NavItem,
  NavLink,
  Nav,
  Card,
  CardBody,
} from "reactstrap";

function NavBarDashboard(props) {
  const {setVista} = props
  const [estado, setState] = useState(null);

 useEffect(() => {    
  });
  
  const toggleNavs = (e, state, index) => {
    e.preventDefault();
   setState(index);
  };
  return (
    <>
     <Card className=" border-0 mb-0 " style={{ width:"100%"}}>
       <CardBody>
      <Nav
          className="nav-fill flex-column flex-sm-row nav-pills"
          id="tabs-text"
          role="tablist"
        >
          <NavItem>
            <NavLink
              aria-selected={estado === 1}
              className={"mb-sm-3 mb-md-0"}
              active={ estado===1}
              onClick={e => {toggleNavs(e, "navPills", 1); setVista("Usuarios")}}
              role="tab"
            >
              Usuarios
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              aria-selected={estado === 2}
              active={ estado===2}
              className={"mb-sm-3 mb-md-0"}
              onClick={e => {toggleNavs(e, "navPills", 2); setVista("Roles")}}
              role="tab"
            >
              Roles
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              aria-selected={estado === 3}
              active={ estado===3}
              className={"mb-sm-3 mb-md-0"}
              onClick={e => {toggleNavs(e, "navPills", 3); setVista("GruposPermisos")}}
              role="tab"
            >
              Grupos Permisos
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              aria-selected={estado === 4}
              active={ estado===4}
              className={"mb-sm-3 mb-md-0"}
              onClick={e => {toggleNavs(e, "navPills", 4); setVista("Graficos")}}
              role="tab"
            >
              Graficos
            </NavLink>
          </NavItem>
        </Nav>
        </CardBody>
        </Card>
    </>
  );
}

NavBarDashboard.defaultProps = {
  toggleSidenav: () => {},
  sidenavOpen: false,
  theme: "dark",
};
NavBarDashboard.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"]),
};

export default NavBarDashboard;
